<!-- 倒计时组件 -->
<template>
  <span><span v-text="value"></span></span>
</template>
<script>
  /* eslint eqeqeq: "off", camelcase: "off" */
  const toStr = (num) => {
    return (100 + num + '').substr(1, 2)
  }

  export default {
    props: {
      format: {
        type: String,
        default: 'hh:mm:ss'
      },

      endcallback: Function,

      deadline: {
        type: Number,
        validator: function (v) {
          return parseInt(v) == v
        },
        required: true
      },

      cssClass: {
        type: String,
        default: ''
      }
    },

    data () {
      return {
        value: '',
        timer: 0,
        started: false
      }
    },

    mounted () {
      if (this.cssClass) this.$el.classList.add(this.cssClass)
      this.updateValue()
      this.timer = setInterval(this.updateValue, 1000)
    },

    destroyed () {
      this.stop()
    },

    methods: {
      stop () {
        if (this.timer) clearInterval(this.timer)
      },

      onEnd () {
        if (this.endcallback && this.started) {
          this.endcallback()
          this.started = false
        }
      },

      updateValue () {
        let now = +new Date()
        if (this.deadline - now < 0) {
          this.onEnd()
          this.stop()
          return
        }

        if (!this.started) {
          this.started = true
        }

        let remain = parseInt((this.deadline - now) / 1000)

        let ss = toStr(remain % 60)
        let mm = toStr(remain % 3600 / 60)
        let hh = toStr(parseInt(remain / 3600))

        if (this.format === 'mm:ss') {
          this.value = mm + ':' + ss
        } else {
          this.value = hh + ':' + mm + ':' + ss
        }
      }
    }
  }
</script>
